import { render, staticRenderFns } from "./FaceDirectionArrow.vue?vue&type=template&id=19a20b52&scoped=true&"
import script from "./FaceDirectionArrow.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionArrow.vue?vue&type=script&lang=ts&"
import style0 from "./FaceDirectionArrow.vue?vue&type=style&index=0&id=19a20b52&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a20b52",
  null
  
)

export default component.exports